
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1201_DiscDialog extends Serenity.Extensions.GridEditorDialog<Report_1201_DiscRow> {
        protected getFormKey() { return Report_1201_DiscForm.formKey; }
        // protected getIdProperty() { return Report_1201_DiscRow.idProperty; }
        protected getLocalTextPrefix() { return Report_1201_DiscRow.localTextPrefix; }
        protected getNameProperty() { return Report_1201_DiscRow.nameProperty; }
        // protected getService() { return Report_1201_DiscService.baseUrl; }
        // protected getDeletePermission() { return Report_1201_DiscRow.deletePermission; }
        // protected getInsertPermission() { return Report_1201_DiscRow.insertPermission; }
        // protected getUpdatePermission() { return Report_1201_DiscRow.updatePermission; }

        protected form = new Report_1201_DiscForm(this.idPrefix);

    }
}